import { createElementBlock as l, openBlock as o, createElementVNode as r } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function t(a, e) {
  return o(), l("svg", n, e[0] || (e[0] = [
    r("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M4.663 10.267A3 3 0 0 1 7.572 8h8.805a3 3 0 0 1 2.917 2.298l1.075 4.468A1 1 0 0 1 19.397 16h-.301l-3.575-4.469a.75.75 0 1 0-1.172.938L17.175 16h-5.08l-3.574-4.469a.75.75 0 1 0-1.172.938L10.175 16h-1.35a1 1 0 1 0 0 2h10.572a3 3 0 0 0 2.916-3.702L21.238 9.83A5 5 0 0 0 16.377 6H7.572a5 5 0 0 0-4.849 3.778l-1.13 4.489A3 3 0 0 0 4.501 18h.461a1 1 0 1 0 0-2h-.461a1 1 0 0 1-.97-1.244z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const i = { render: t };
export {
  i as default,
  t as render
};
//# sourceMappingURL=ic_rear_window-C35zMoMu.js.map
